import type React from 'react';
import { useIntl } from 'react-intl';

import { getTemplateHeaderFontSize } from '@xing-com/crate-lebenslauf-helpers';
import { useReadCoverLetter } from '@xing-com/crate-lebenslauf-hooks';

import { usePersonalData } from './';
import {
  Container,
  ProfileImage,
  Name,
  NameField,
  PersonalData,
  Item,
  Tag,
} from './header.styled';

type HeaderProps = {
  pageIndex: number;
};

export const Header: React.FC<HeaderProps> = ({ pageIndex }) => {
  const coverLetter = useReadCoverLetter();
  const personalData = usePersonalData();
  const intl = useIntl();

  if (!coverLetter) return null;

  const firstName = coverLetter?.personalInformation?.firstName;
  const lastName = coverLetter?.personalInformation?.lastName;
  const coverLetterTag = intl.formatMessage({
    id: 'CRATE_VITA_TEMPLATE_COVER_LETTER_TAG',
  });
  const fontSize = getTemplateHeaderFontSize({
    textLength: Math.max(firstName?.length || 0, lastName?.length || 0),
    resizeAfterIndex: 5,
    max: 40,
    min: 20,
  });
  const fileAttachments = coverLetter.fileAttachments;
  const image = coverLetter.fileAttachments?.profileImage?.url;

  return (
    <Container>
      {pageIndex === 0 ? (
        <>
          <ProfileImage
            fileAttachments={fileAttachments}
            width="112"
            height="112"
          />
          <Name $hasImage={!!image}>
            <NameField {...fontSize}>{firstName}</NameField>
            <NameField {...fontSize}>{lastName}</NameField>
          </Name>
          <PersonalData data-qa="preview-section-personal-info">
            {personalData.map((data, index) => (
              <Item key={index}>{data}</Item>
            ))}
          </PersonalData>
        </>
      ) : null}
      <Tag>{coverLetterTag}</Tag>
    </Container>
  );
};
